import React, { useState, useEffect } from "react";
import { collection, getDocs, deleteDoc, addDoc, doc, updateDoc, setDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/credenciales";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan } from '@fortawesome/free-solid-svg-icons';
import factory from "../../assets/factory.png";
import bbva from "../../assets/bbva.png";
import DatePicker from 'react-datepicker';
import { addDays } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import "./Factory.css";

const Factory = ({ userId }) => {
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [currentValue, setCurrentValue] = useState("");
    const [voltage, setVoltage] = useState("48");
    const [numControlador, setnumControlador] = useState("1");
    const [numInversor, setnumInversor] = useState("2");
    const [batteryType, setBatteryType] = useState("Litio");
    const [percentage, setPercentage] = useState("100%");
    const [calculatedValue, setCalculatedValue] = useState(0);
    const [selectedBattery, setSelectedBattery] = useState("");
    const [numBatteries, setNumBatteries] = useState(1);
    const [batteries, setBatteries] = useState([]);
    const [totalAh, setTotalAh] = useState(0);
    const [totalKWh, setTotalKWh] = useState(0);
    const [ahNecesarios, setAhNecesarios] = useState(0);
    const [amperios, setAmperios] = useState(0);
    const [controllers, setControllers] = useState([]);
    const [selectedController, setSelectedController] = useState("");
    const [ahSuministrados, setAhSuministrados] = useState(0);
    const [modulePower, setModulePower] = useState("600");
    const [cantidadSugerida, setCantidadSugerida] = useState(0);
    const [modulosPropuestos, setModulosPropuestos] = useState("32");
    const [potenciaSTC, setPotenciaSTC] = useState(0);
    const [corriente48V, setCorriente48V] = useState(0);
    const [anuncio, setAnuncio] = useState("");
    const [fases, setFases] = useState("2");
    const [systemVoltage, setSystemVoltage] = useState("220");
    const [inversores, setInversores] = useState([]);
    const [selectedInversor, setSelectedInversor] = useState("");
    const [proteccion, setProteccion] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [equipmentData, setEquipmentData] = useState([]);
    const [totalPower, setTotalPower] = useState(0);
    const [totalEnergy, setTotalEnergy] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [moneda, setMoneda] = useState("MXN");
    const [precioModulo, setPrecioModulo] = useState(0);
    const [importeModulo, setImporteModulo] = useState(0);
    const [batteryDescription, setBatteryDescription] = useState('');
    const [batteryNomenclatura, setBatteryNomenclatura] = useState('');
    const [batteryPrice, setBatteryPrice] = useState(0);
    const [importeBateria, setImporteBateria] = useState(0);
    const [controlllerDescription, setControlllerDescription] = useState('');
    const [controllerPrice, setControllerPrice] = useState(0);
    const [importeControlador, setImporteControlador] = useState(0);
    const [inversorDescription, setInversorDescription] = useState('');
    const [inversorPrice, setInversorPrice] = useState(0);
    const [importeInversor, setImporteInversor] = useState(0);
    const [cable, setCable] = useState(0);
    const [cablePrice, setCablePrice] = useState(0);
    const [importeCable, setImporteCable] = useState(0);
    const [conector, setConector] = useState(0);
    const [conectorPrice, setConectorPrice] = useState(0);
    const [importeConector, setImporteConector] = useState(0);
    const [conectory, setConectorY] = useState(0);
    const [conectorYPrice, setConectorYPrice] = useState(0);
    const [importeConectorY, setImporteConectorY] = useState(0);
    const [precioProtection, setPrecioProtection] = useState(0);
    const [importePrecioProtection, setImportePrecioProtection] = useState(0);
    const [precioKitCables, setPrecioKitCables] = useState(0);
    const [importeKitCables, setImporteKitCables] = useState(0);
    const [kitCablesBaterry, setKitCablesBaterry] = useState(0);
    const [precioKitCablesBaterry, setPrecioKitCablesBaterry] = useState(0);
    const [importeKitCablesBaterry, setImporteKitCablesBaterry] = useState(0);
    const [kitEstuctura, setKitEstuctura] = useState(0);
    const [precioKitEstuctura, setPrecioKitEstuctura] = useState(0);
    const [importeKitEstuctura, setImporteKitEstuctura] = useState(0);
    const [barra, setBarra] = useState(0);
    const [precioBarra, setPrecioBarra] = useState(0);
    const [importeBarra, setImporteBarra] = useState(0);
    const [precioManoObra, setPrecioManoObra] = useState(0);
    const [importeManoObra, setImporteManoObra] = useState(0);
    const [subtotalImporte, setSubtotalImporte] = useState(0);
    const [ivaImporte, setIvaImporte] = useState(0);
    const [totalImporte, setTotalImporte] = useState(0);
    const [total, setTotal] = useState(0);
    const [clientData, setClientData] = useState({
        cliente: "Juan Pérez",
        razonSocial: "Energía Solar S.A. de C.V.",
        calle: "Calle Principal 123",
        colonia: "Colonia Centro",
        municipio: "Oaxaca de Juárez",
        rfc: "ES123456789",
        numero: "001",
        ciudad: "Oaxaca",
        estado: "Oaxaca",
        cp: "68000",
    });

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const folio = `CSE-${year - 2000}-${month.toString().padStart(2, '0')}-000${day.toString().padStart(2, '0')}`;

    const headerData = {
        fecha: now.toLocaleDateString('es-MX'),
        moneda: "USD",
        dof: 20000,
        folio: folio,
        vigencia: addDays(startDate, 10),
        tiempoEntrega: "2 semanas",
    };

    const handleWheel = (e) => {
        if (e.target.type === 'number') {
            e.target.blur();
        }
    };

    const handleCancelNewEquipment = (id) => {
        const updatedData = equipmentData.filter((equipment) => equipment.id !== id);
        setEquipmentData(updatedData);
        Swal.fire("Cancelado", "El equipo no fue agregado.");
    };

    const handleAddRow = () => {
        const newRow = {
            id: Date.now().toString(),
            name: "",
            quantity: null,
            power: null,
            time: null,
            isNew: true,
        };
        setEquipmentData((prevData) => [...prevData, newRow]);
    };

    const handleSaveNewEquipment = async (id) => {
        const newEquipment = equipmentData.find((item) => item.id === id);
        if (!newEquipment.name || newEquipment.quantity === null || newEquipment.power === null || newEquipment.time === null) {
            Swal.fire("Error", "Todos los campos deben estar completos.");
            return;
        }

        try {
            const docRef = await addDoc(collection(db, `usuarios/${userId}/Equipos`), {
                name: newEquipment.name,
                quantity: newEquipment.quantity,
                power: newEquipment.power,
                time: newEquipment.time,
            });
            setEquipmentData((prevData) =>
                prevData.map((item) =>
                    item.id === id ? { ...newEquipment, id: docRef.id, isNew: false } : item
                )
            );
            Swal.fire("Guardado", "El equipo ha sido guardado exitosamente.");
        } catch (error) {
            console.error("Error al guardar el equipo en la base de datos", error);
            Swal.fire("Error", "No se pudo guardar el equipo.");
        }
    };

    useEffect(() => {
        const fetchEquipmentData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, `usuarios/${userId}/Equipos`));
                const data = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setEquipmentData(data);
            } catch (error) {
                console.error("Error al cargar datos:", error);
                Swal.fire("Error", "No se pudieron cargar los datos.");
            }
        };
        fetchEquipmentData();
    }, [userId]);

    const handleInputChange = (id, field, value) => {
        const updatedData = equipmentData.map((equipment) =>
            equipment.id === id ? { ...equipment, [field]: value } : equipment
        );
        setEquipmentData(updatedData);
    };

    const handleUpdate = async (id) => {
        const equipment = equipmentData.find((item) => item.id === id);
        try {
            await updateDoc(doc(db, `usuarios/${userId}/Equipos`, id), equipment);
            Swal.fire("Actualizado", "Los datos se han guardado correctamente.");
        } catch (error) {
            console.error("Error al actualizar Firestore:", error);
            Swal.fire("Error", "No se pudieron guardar los cambios.");
        }
    };

    const handleDeleteEquipment = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás deshacer esta acción",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, `usuarios/${userId}/Equipos`, id));
                const updatedEquipmentData = equipmentData.filter(
                    (equipment) => equipment.id !== id
                );
                setEquipmentData(updatedEquipmentData);
                Swal.fire("Eliminado", "El equipo ha sido eliminado.");
            } catch (error) {
                console.error("Error al eliminar el equipo:", error);
                Swal.fire("Error", "Hubo un problema al eliminar el equipo.");
            }
        }
    };

    useEffect(() => {
        const newTotalPower = equipmentData.reduce(
            (acc, equipment) => acc + equipment.quantity * equipment.power,
            0
        );
        const newTotalEnergy = equipmentData.reduce(
            (acc, equipment) => acc + equipment.quantity * equipment.power * equipment.time,
            0
        );
        setTotalPower(newTotalPower);
        setTotalEnergy(newTotalEnergy);
        const updateFirebase = async () => {
            const docRef = doc(db, `usuarios/${userId}/TotalesPE`, "Totales");
            await setDoc(docRef, {
                totalPower: newTotalPower,
                totalEnergy: newTotalEnergy,
            }, { merge: true });
        }
        updateFirebase();
    }, [equipmentData, userId]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const statesSnapshot = await getDocs(collection(db, 'Ciudades'));
            const batteriesSnapshot = await getDocs(collection(db, 'Baterias'));
            const controllersSnapshot = await getDocs(collection(db, 'Controladores'));
            const inversoresSnapshot = await getDocs(collection(db, 'Inversores'));
            const statesData = statesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            const batteriesData = batteriesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            const controllersData = controllersSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            const inversoresData = inversoresSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            statesData.sort((a, b) => a.city.localeCompare(b.city));
            setStates(statesData);
            setBatteries(batteriesData);
            setControllers(controllersData);
            setInversores(inversoresData);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, `usuarios/${userId}/TotalesPE`, 'Totales'), (doc) => {
            if (doc.exists()) {
                setTotalEnergy(doc.data().totalEnergy);
            } else {
                console.log("No such document!");
            }
        });

        return () => unsubscribe();
    }, [userId]);

    useEffect(() => {
        if (selectedState && states.length > 0) {
            const state = states.find(state => state.city === selectedState);
            if (state) {
                const currentMonth = new Date().getMonth();
                let value;
                if (currentMonth === 0) {
                    value = state.Enero;
                } else if (currentMonth === 1) {
                    value = state.Febrero;
                } else if (currentMonth === 2) {
                    value = state.Marzo;
                } else if (currentMonth === 3) {
                    value = state.Abril;
                } else if (currentMonth === 4) {
                    value = state.Mayo;
                } else if (currentMonth === 5) {
                    value = state.Junio;
                } else if (currentMonth === 6) {
                    value = state.Julio;
                } else if (currentMonth === 7) {
                    value = state.Agosto
                } else if (currentMonth === 8) {
                    value = state.Septiembre;
                } else if (currentMonth === 9) {
                    value = state.Octubre;
                } else if (currentMonth === 10) {
                    value = state.Noviembre;
                } else if (currentMonth === 11) {
                    value = state.Diciembre;
                }
                setCurrentValue(value);
            }
        }
    }, [selectedState, states]);

    useEffect(() => {
        if (batteryType === "Litio") {
            setPercentage("100%");
        } else if (batteryType === "Gel") {
            setPercentage("50%");
        }
    }, [batteryType]);

    useEffect(() => {
        if (totalEnergy && voltage && percentage) {
            const percentageValue = parseFloat(percentage) / 100;
            const calculated = (totalEnergy / (voltage * percentageValue)).toFixed(1);
            setCalculatedValue(calculated);
        }
    }, [totalEnergy, voltage, percentage]);

    useEffect(() => {
        if (selectedBattery && batteries.length > 0) {
            const selectedBatteryData = batteries.find(battery => battery.id === selectedBattery);
            if (selectedBatteryData) {
                const batteryCapacity = parseFloat(selectedBatteryData.Wh);
                const divisionResult = totalEnergy / batteryCapacity;
                let roundedBatteries = Math.ceil(divisionResult);
                if (roundedBatteries % 2 !== 0) {
                    roundedBatteries += 1;
                }
                if (totalEnergy < 4560) {
                    setNumBatteries(1);
                } else {
                    setNumBatteries(roundedBatteries);
                }
                const totalAhValue = numBatteries * selectedBatteryData.Ah;
                const totalKWhValue = (numBatteries * selectedBatteryData.Wh) / 1000;
                setTotalAh(totalAhValue);
                setTotalKWh(totalKWhValue);
            }
        }
        if (selectedBattery) {
            const battery = batteries.find(bat => bat.id === selectedBattery);
            if (battery) {
                setBatteryDescription(battery.Description);
                setBatteryPrice(battery.Price);
                setBatteryNomenclatura(`${battery.name} / ${battery.Wh} Wh`);
            }
        }
        const importeBattery = numBatteries * batteryPrice;
        setImporteBateria(importeBattery);
        const kitCablesBattery = Math.ceil(numBatteries / 2);
        setKitCablesBaterry(kitCablesBattery);
        const precioKitCablesBattery = 1 * 55;
        setPrecioKitCablesBaterry(precioKitCablesBattery);
        const importeKitCablesBattery = kitCablesBattery * precioKitCablesBattery;
        setImporteKitCablesBaterry(importeKitCablesBattery);
        const barra = Math.ceil(numBatteries / 4);
        setBarra(barra);

        if (barra === 0) {
            setPrecioBarra(0);
        } else {
            setPrecioBarra(217);
        }

        const importeBarra = barra * precioBarra;
        setImporteBarra(importeBarra);

    }, [totalEnergy, selectedBattery, numBatteries, batteries, batteryPrice, batteryDescription, batteryNomenclatura, precioKitCablesBaterry, precioBarra]);

    useEffect(() => {
        if (totalEnergy && voltage) {
            const ahNecesariosValue = (totalEnergy / voltage).toFixed(1);
            setAhNecesarios(ahNecesariosValue);
        }
    }, [totalEnergy, voltage]);

    useEffect(() => {
        if (totalAh && currentValue) {
            const amperiosValue = Math.round(totalAh / currentValue);
            setAmperios(amperiosValue);
        }
    }, [totalAh, currentValue]);

    useEffect(() => {
        if (totalAh && currentValue) {
            const value = totalAh / currentValue;
            let controller;
            if (value < 100) {
                controller = controllers.find(ctrl => Math.abs(ctrl.Amperes - value) < 10);
            } else {
                controller = controllers.find(ctrl => Math.abs(ctrl.Amperes - (value - 1)) < 10);
            }
            if (controller) {
                setSelectedController(`${controller.Voltage}V / ${controller.Amperes}A`);
                setAhSuministrados((currentValue * controller.Amperes).toFixed(2));
                const cantidad = Math.ceil((voltage * controller.Amperes) / parseFloat(modulePower));
                if (cantidad % 2 !== 0) {
                    setCantidadSugerida(cantidad + 1);
                } else {
                    setCantidadSugerida(cantidad);
                }
                setCorriente48V(controller.Amperes * 1);
                if (controller.Amperes * 1.2 * 1 < corriente48V) {
                    setAnuncio("¡Corriente elevada!, reducir potencia de módulos");
                } else {
                    const ahSuministrados = Math.floor(0.77 * (modulosPropuestos * modulePower / voltage) * currentValue);
                    setAnuncio(`Con ${modulosPropuestos} módulos de ${modulePower} se suministran ${ahSuministrados} Ah`);
                }
                setControlllerDescription(controller.Description);
                setControllerPrice(controller.Price);
                const importeController = numControlador * controllerPrice;
                setImporteControlador(importeController);
            }
        }
    }, [totalAh, currentValue, controllers, voltage, modulePower, corriente48V, modulosPropuestos, numControlador, controllerPrice]);

    useEffect(() => {
        if (modulePower && modulosPropuestos) {
            const potencia = parseFloat(modulePower) * parseFloat(modulosPropuestos);
            setPotenciaSTC(potencia);
        }
        if (modulePower) {
            const precio = 1 * modulePower * 0.2;
            setPrecioModulo(precio);
            const importe = precio * modulosPropuestos;
            setImporteModulo(importe);
            const cable = modulosPropuestos * 10;
            setCable(cable);
            const precioCable = 1 * 1;
            setCablePrice(precioCable);
            const importeCable = cable * precioCable;
            setImporteCable(importeCable);
            const conector = modulosPropuestos / 2;
            setConector(conector);
            const precioConector = 1 * 2.5;
            setConectorPrice(precioConector);
            const importeConector = conector * precioConector;
            setImporteConector(importeConector);
            const conectorY = conector / 2;
            setConectorY(conectorY);
            const precioConectorY = 1 * 12;
            setConectorYPrice(precioConectorY);
            const importeConectorY = conectorY * precioConectorY;
            setImporteConectorY(importeConectorY);
            const precioKitCables = 1 * importe * 0.25;
            setPrecioKitCables(precioKitCables);
            const importeKitCables = 1 * precioKitCables;
            setImporteKitCables(importeKitCables);
            const kitEstructura = (1);
            setKitEstuctura(kitEstructura);
            const precioKitEstructura = (kitEstructura * modulosPropuestos * modulePower * 0.09);
            setPrecioKitEstuctura(precioKitEstructura);
            const importeKitEstructura = (kitEstructura * precioKitEstructura);
            setImporteKitEstuctura(importeKitEstructura);
            const precioManoObra = modulosPropuestos * 120;
            setPrecioManoObra(precioManoObra);
            const importeManoObra = precioManoObra * 1;
            setImporteManoObra(importeManoObra);
        }
    }, [modulePower, modulosPropuestos]);

    useEffect(() => {
        if (selectedInversor && voltage) {
            const inversor = inversores.find(inv => inv.Nomenclatura === selectedInversor);
            if (inversor) {
                const wp = inversor.Wp;
                const value = wp / voltage;
                const protectionValues = [16, 20, 32, 40, 80, 100, 125, 160, 200, 250];
                const precioProtectionValues = [26, 26, 26, 35, 92.50, 92.50, 96.20, 96.20, 99.90, 99.90];
                const filteredValues = protectionValues.filter(val => val <= value);
                const protection = filteredValues.length > 0 ? Math.max(...filteredValues) : 250;
                setProteccion(protection);
                const precioProtection = precioProtectionValues[protectionValues.indexOf(protection)];
                setPrecioProtection(precioProtection);
            }
            setInversorDescription(inversor.Description);
            setInversorPrice(inversor.Price);
            const importeInversor = numInversor * inversorPrice;
            setImporteInversor(importeInversor);
            const importePrecioProtection = numInversor * precioProtection;
            setImportePrecioProtection(importePrecioProtection);
        }
    }, [selectedInversor, voltage, inversores, numInversor, inversorPrice, precioProtection]);


    useEffect(() => {
        const subtotal = importeModulo + importeControlador + importeBateria + importeInversor + 150.00 + importeCable + importeConector + importeConectorY + importePrecioProtection + importeKitCables + importeKitCablesBaterry + importeKitEstuctura + importeBarra + 372.00 + importeManoObra;
        setSubtotalImporte(subtotal);
        const iva = subtotal * 0.16;
        setIvaImporte(iva);
        const totalImporte = subtotal + iva;
        setTotalImporte(totalImporte);
        const total = totalImporte * parseFloat(headerData.dof.toFixed(2));
        setTotal(total);
    }, [importeModulo, importeControlador, importeBateria, importeInversor, importeCable, importeConector, importeConectorY, importePrecioProtection, importeKitCables, importeKitCablesBaterry, importeKitEstuctura, importeBarra, importeManoObra, headerData.dof]);

    const handleStateChange = (e) => {
        setSelectedState(e.target.value);
    };

    const handleVoltageChange = (e) => {
        setVoltage(e.target.value);
    };

    const handleControladorChange = (e) => {
        setnumControlador(e.target.value);
    };

    const handleInversorsChange = (e) => {
        setnumInversor(e.target.value);
    };

    const handleBatteryTypeChange = (e) => {
        setBatteryType(e.target.value);
    };

    const handleBatteryChange = (e) => {
        setSelectedBattery(e.target.value);
    };

    const handleModulePowerChange = (e) => {
        setModulePower(e.target.value);
    };

    const handleModulosPropuestosChange = (e) => {
        setModulosPropuestos(e.target.value);
    };

    const handleFasesChange = (e) => {
        setFases(e.target.value);
    };

    const handleSystemVoltageChange = (e) => {
        setSystemVoltage(e.target.value);
    };

    const handleInversorChange = (e) => {
        setSelectedInversor(e.target.value);
    };

    const handleClientInputChange = (e) => {
        const { name, value } = e.target;
        setClientData({
            ...clientData,
            [name]: value
        });
    };

    return (
        <div className="equipment-container">
            <div className="title-container">
                <button className="add-btn" title="Agregar Electrodoméstico" onClick={handleAddRow}>
                    <FontAwesomeIcon icon={faAdd} />
                </button>
                <h2>Equipos Registrados</h2>
            </div>
            <table className="equipment-table">
                <thead>
                    <tr className="table-header">
                        <th>Acciones</th>
                        <th>Equipo</th>
                        <th>Cantidad</th>
                        <th>Potencia (W)</th>
                        <th>Tiempo (h)</th>
                        <th>Potencia Total (W)</th>
                        <th>Energía Total (Wh)</th>
                    </tr>
                </thead>
                <tbody>
                    {equipmentData.length > 0 ? (
                        <>
                            {equipmentData.map((equipment) => (
                                <tr key={equipment.id}>
                                    <td>
                                        <div className="button-container">
                                            {equipment.isNew ? (
                                                <>
                                                    <button
                                                        className="save-btn"
                                                        title="Guardar"
                                                        onClick={() => handleSaveNewEquipment(equipment.id)}
                                                    >
                                                        <FontAwesomeIcon icon={faAdd} />
                                                    </button>
                                                    <button
                                                        className="cancel-btn"
                                                        title="Cancelar"
                                                        onClick={() => handleCancelNewEquipment(equipment.id)}
                                                    >
                                                        <FontAwesomeIcon icon={faBan} />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <button
                                                        className="update-btn"
                                                        title="Actualizar"
                                                        onClick={() => handleUpdate(equipment.id)}
                                                    >
                                                        <FontAwesomeIcon icon={faRotate} />
                                                    </button>
                                                    <button
                                                        className="delete-btn"
                                                        title="Eliminar"
                                                        onClick={() => handleDeleteEquipment(equipment.id)}
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <input
                                            className="q-input"
                                            type="text"
                                            value={equipment.name}
                                            onChange={(e) =>
                                                handleInputChange(equipment.id, "name", e.target.value)
                                            }
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="q-input"
                                            min="0"
                                            step="any"
                                            type="number"
                                            value={equipment.quantity}
                                            onWheel={handleWheel}
                                            onChange={(e) =>
                                                handleInputChange(equipment.id, "quantity", e.target.value)
                                            }
                                            style={{ width: "50px", textAlign: "center" }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="q-input"
                                            min="0"
                                            step="any"
                                            type="number"
                                            value={equipment.power}
                                            onWheel={handleWheel}
                                            onChange={(e) =>
                                                handleInputChange(equipment.id, "power", e.target.value)
                                            }
                                            style={{ width: "60px", textAlign: "center" }}
                                        />{" "}W
                                    </td>
                                    <td>
                                        <input
                                            className="q-input"
                                            min="0"
                                            step="any"
                                            type="number"
                                            value={equipment.time}
                                            onWheel={handleWheel}
                                            onChange={(e) =>
                                                handleInputChange(equipment.id, "time", e.target.value)
                                            }
                                            style={{ width: "50px", textAlign: "center" }}
                                        />{" "}{Number(equipment.time) === 1 ? "hora" : "horas"}
                                    </td>
                                    <td>{equipment.quantity * equipment.power} W</td>
                                    <td>{equipment.quantity * equipment.power * equipment.time} Wh</td>
                                </tr>
                            ))}
                            <tr className="total-row">
                                <td className="total-row1" colSpan="5">Total</td>
                                <td className="total-row1">
                                    {totalPower} W
                                </td>
                                <td className="total-row1">
                                    {totalEnergy} Wh
                                </td>
                            </tr>
                        </>
                    ) : (
                        <tr>
                            <td className="alert-data" colSpan="7">
                                No se han registrado equipos aún. <br />
                                Por favor, agrega un nuevo equipo para comenzar.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <table className="data-table">
                <tbody>
                    <tr>
                        <th colSpan="10"></th>
                    </tr>
                    <tr>
                        <td colSpan="2" className="color-blue">
                            <select value={selectedState} onChange={handleStateChange}>
                                <option value="" disabled>Seleccione una ciudad</option>
                                {states.map(state => (
                                    <option key={state.id} value={state.city}>
                                        {state.city}
                                    </option>
                                ))}
                            </select>
                        </td>
                        <td>
                            {currentValue ? `${currentValue} horas` : 'Seleccione un estado'}
                        </td>
                        <td>Tensión de sistema</td>
                        <td className="color-blue"> <input
                            type="text"
                            value={voltage}
                            onChange={handleVoltageChange}
                            className="input-voltage"
                        /> V</td>
                        <td>DOD</td>
                        <td>{percentage}</td>
                        <td>Ah al {percentage} DOD</td>
                        <td>{calculatedValue} Ah</td>
                    </tr>
                    <tr>
                        <td>Tipo:</td>
                        <td className="input-battery-type">
                            <select value={batteryType} onChange={handleBatteryTypeChange}>
                                <option value="Litio">Litio</option>
                                <option value="Gel">Gel</option>
                            </select>
                        </td>
                        <td className="color-blue">
                            <select value={selectedBattery} onChange={handleBatteryChange} className="color-blue">
                                <option value="" disabled>Seleccione una batería</option>
                                {batteries.map(battery => (
                                    <option key={battery.id} value={battery.id}>
                                        {`${battery.name} / ${battery.Wh} Wh`}
                                    </option>
                                ))}
                            </select>
                        </td>
                        <td>No. de baterías</td>
                        <td className="color-red">{numBatteries}</td>
                        <td>Ah Totales</td>
                        <td>{totalAh} Ah</td>
                        <td>kWh Totales</td>
                        <td className="color-red">{totalKWh.toFixed(2)} kWh</td>
                    </tr>
                    <tr>
                        <td>Ah necesarios al día</td>
                        <td>{ahNecesarios} Ah</td>
                        <td>{amperios} A</td>
                        <td><input
                            type="text"
                            value={numControlador}
                            onChange={handleControladorChange}
                            className="input-controlador"
                        /></td>
                        <td>Controlador:</td>
                        <td colSpan="2" className="color-red">{selectedController ? selectedController : 'Seleccione un estado y una batería'}</td>
                        <td>Ah Suministrados</td>
                        <td>{ahSuministrados} Ah</td>
                    </tr>
                    <tr>
                        <td>Potencia de módulo:</td>
                        <td colSpan="2" className="color-blue">
                            <input
                                type="text"
                                value={modulePower}
                                onChange={handleModulePowerChange}
                                className="input-module-power"
                            /> Wp
                        </td>
                        <td>Cantidad sugerida</td>
                        <td colSpan="2">{cantidadSugerida}</td>
                        <td>Potencia STC</td>
                        <td colSpan="2">{potenciaSTC} Wp</td>
                    </tr>
                    <tr>
                        <td>Módulos propuestos:</td>
                        <td className="color-red">
                            <input
                                type="text"
                                value={modulosPropuestos}
                                onChange={handleModulosPropuestosChange}
                                className="input-modulos-propuestos"
                            />
                        </td>
                        <td>Corriente a 48V:</td>
                        <td>{corriente48V} A</td>
                        <td colSpan="5" className="color-grey">{anuncio ? anuncio : 'Seleccione un estado y una batería'}</td>
                    </tr>
                    <tr>
                        <td>Fases</td>
                        <td className="input-fases">
                            <select value={fases} onChange={handleFasesChange} className="input-fases">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select>
                        </td>
                        <td>Voltaje</td>
                        <td className="color-blue">
                            <select value={systemVoltage} onChange={handleSystemVoltageChange}>
                                <option value="220">220</option>
                                <option value="110">110</option>
                            </select>
                        </td>
                        <td><input
                            type="text"
                            value={numInversor}
                            onChange={handleInversorsChange}
                            className="input-controlador"
                        /></td>
                        <td>Inversor</td>
                        <td className="color-red">
                            <select value={selectedInversor} onChange={handleInversorChange} className="color-red">
                                <option value="" disabled>Seleccione un inversor</option>
                                {inversores.map(inversor => (
                                    <option key={inversor.id} value={inversor.Nomenclatura}>
                                        {inversor.Nomenclatura}
                                    </option>
                                ))}
                            </select>
                        </td>
                        <td>Protección</td>
                        <td className="color-red">{proteccion}</td>
                    </tr>
                </tbody>
            </table>

            <table className="equipment-table1">
                <tr>
                    <td colspan="2">
                        <p><strong>Fecha: </strong>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="fecha"
                            />
                        </p>
                    </td>
                    <td colspan="2">
                        <p><strong>Moneda: </strong>
                            <select className="moneda" value={moneda} onChange={(e) => setMoneda(e.target.value)}>
                                <option value="MXN">MXN</option>
                                <option value="USD">USD</option>
                            </select>
                        </p>
                    </td>
                    <td colspan="2">
                        <p><strong>DOF:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(headerData.dof)}</p>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <p className="vigencia"><strong>Vigencia: </strong>
                            {headerData.vigencia.toLocaleDateString()}
                        </p>
                    </td>
                    <td colspan="2">
                        <p><strong>Tiempo de entrega:</strong> {headerData.tiempoEntrega}</p>
                    </td>
                    <td colspan="2">
                        <p><strong>Folio:</strong> {headerData.folio}</p>
                    </td>
                </tr>
            </table>

            <table className="equipment-table2">
                <tbody>
                    <tr>
                        <td><strong>Cliente:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="cliente"
                                value={clientData.cliente}
                                onChange={handleClientInputChange}
                            />
                        </td>
                        <td><strong>R.F.C:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="rfc"
                                value={clientData.rfc}
                                onChange={handleClientInputChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Razón Social:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="razonSocial"
                                value={clientData.razonSocial}
                                onChange={handleClientInputChange}
                            />
                        </td>
                        <td><strong>Número:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="numero"
                                value={clientData.numero}
                                onChange={handleClientInputChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Calle:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="calle"
                                value={clientData.calle}
                                onChange={handleClientInputChange}
                            />
                        </td>
                        <td><strong>Ciudad:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="ciudad"
                                value={clientData.ciudad}
                                onChange={handleClientInputChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Colonia:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="colonia"
                                value={clientData.colonia}
                                onChange={handleClientInputChange}
                            />
                        </td>
                        <td><strong>Estado:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="estado"
                                value={clientData.estado}
                                onChange={handleClientInputChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Municipio:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="municipio"
                                value={clientData.municipio}
                                onChange={handleClientInputChange}
                            />
                        </td>
                        <td><strong>C.P:</strong></td>
                        <td>
                            <input
                                className="form-input"
                                type="text"
                                name="cp"
                                value={clientData.cp}
                                onChange={handleClientInputChange}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>

            <h1 className="quotation-title">Detalles de Cotización</h1>
            <table className="quotation-table">
                <thead>
                    <tr>
                        <th>Cantidad</th>
                        <th>Unidad</th>
                        <th>Descripción</th>
                        <th>P. Unitario</th>
                        <th>Importe</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{modulosPropuestos}</td>
                        <td>Pieza</td>
                        <td>Módulos fotovoltaicos de {modulePower} Wp con certificaciones UL 1703: CSA, IEC 61215 / IEC 61730: VDE / CE</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioModulo)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeModulo)}</td>
                    </tr>
                    <tr>
                        <td>{numControlador}</td>
                        <td>Pieza</td>
                        <td>{controlllerDescription}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(controllerPrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeControlador)}</td>
                    </tr>
                    <tr>
                        <td>{numBatteries}</td>
                        <td>Pieza</td>
                        <td>{batteryDescription}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(batteryPrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeBateria)}</td>
                    </tr>
                    <tr>
                        <td>{numInversor}</td>
                        <td>Pieza</td>
                        <td>{inversorDescription}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(inversorPrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeInversor)}</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Pieza</td>
                        <td>Gabinete para Montaje en Pared, Cuerpo Fijo con Rack 19" con capacidad hasta 1 baterías de litio</td>
                        <td>$150.00</td>
                        <td>$150.00</td>
                    </tr>
                    <tr>
                        <td>{cable}</td>
                        <td>Metro</td>
                        <td>Cable fotovoltaico 10 AWG XLPE, PV, 2000V, Tipo UL P/RHH RHW-2</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cablePrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeCable)}</td>
                    </tr>
                    <tr>
                        <td>{conector}</td>
                        <td>Pieza</td>
                        <td>Conector MC4 PV SolarLine (macho & hembra) marca Stäubli</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(conectorPrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeConector)}</td>
                    </tr>
                    <tr>
                        <td>{conectory}</td>
                        <td>Pieza</td>
                        <td>Conector "Y" MC4 PV SolarLine (macho & hembra) marca Stäubli</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(conectorYPrice)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeConectorY)}</td>
                    </tr>
                    <tr>
                        <td>{numInversor}</td>
                        <td>Pieza</td>
                        <td>Seccionador de corriente continua a {proteccion}A DC</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioProtection)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importePrecioProtection)}</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Pieza</td>
                        <td>Kit cables de comunicación, ferrules, y accesorios para montaje</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioKitCables)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeKitCables)}</td>
                    </tr>
                    <tr>
                        <td>{kitCablesBaterry}</td>
                        <td>Pieza</td>
                        <td>Kit de cables para baterías {batteryNomenclatura}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioKitCablesBaterry)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeKitCablesBaterry)}</td>
                    </tr>
                    <tr>
                        <td>{kitEstuctura}</td>
                        <td>Pieza</td>
                        <td>Kit para estructura de montaje para módulos fotovoltaicos de 60/72 Celdas UL 2703, marca Everest</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioKitEstuctura)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeKitEstuctura)}</td>
                    </tr>
                    <tr>
                        <td>{barra}</td>
                        <td>Pieza</td>
                        <td>Barra De Bus De CC Modular CC Lynx Distributor</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioBarra)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeBarra)}</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Pieza</td>
                        <td>Centro de comunicaciones Cerbo GX y pantalla GX (incluye cables de comunicación)</td>
                        <td>$372.00</td>
                        <td>$372.00</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Servicio</td>
                        <td>Mano de obra</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(precioManoObra)}</td>
                        <td>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importeManoObra)}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td className="text-bold" rowSpan="3" style={{ verticalAlign: "top" }}>Nota:</td>
                        <td className="text-bold" colSpan="2" rowSpan="3" style={{ textAlign: "left" }}>
                            La presente cotización contempla un consumo de 4100 Wh, en caso de tener modificaciones en equipos notificar para volver a cotizar, no contempla mano de obra.
                        </td>
                        <td>Subtotal {moneda}</td>
                        <td style={{ textAlign: "right" }}>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotalImporte)}</td>
                    </tr>
                    <tr>
                        <td>IVA {moneda}</td>
                        <td style={{ textAlign: "right" }}>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ivaImporte)}</td>
                    </tr>
                    <tr>
                        <td>Total {moneda}</td>
                        <td style={{ textAlign: "right" }}>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totalImporte)}</td>
                    </tr>
                    <tr>
                        <td style={{ verticalAlign: "top", textAlign: "center" }}>
                            <img src={bbva} alt="Energía sostenible" style={{ maxWidth: "100px" }} />
                        </td>
                        <td className="text-bold">
                            <p><strong>Clave:</strong> 0126 1000 1124 0736 17</p>
                        </td>
                        <td className="text-bold">
                            <p><strong>Clave:</strong> 0126 1000 1124 0736 17</p>
                        </td>
                        <td className="text-bold">Total MXN</td>
                        <td className="text-bold" style={{ textAlign: "right" }}>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total)}</td>
                    </tr>
                </tfoot>

            </table>

            <h1 className="politicas-titulo">Políticas de Facturación</h1>
            <p className="politicas-texto">
                Para poder facturar deberá estar dado de alta en el SAT; ser una persona física o moral.<br />
                Deberá solicitar su factura al siguiente correo: <strong>finanzas@civicsun.com</strong> en el momento de la confirmación de la compra, enviando los siguientes datos:
            </p>
            <ul>
                <li>Nombre completo o razón social</li>
                <li>RFC con homoclave</li>
                <li>Domicilio fiscal</li>
                <li>Uso de CFDI</li>
            </ul>
            <p className="politicas-texto">
                Se tendrá como fecha límite para recepción de los datos fiscales 24 horas antes del último día del mes, sin considerar sábados, domingos y días festivos.<br />
                Se facturarán los siguientes pagos:
            </p>
            <ul>
                <li>Pagos en efectivo en montos menores a $2,000 M.N.</li>
                <li>Transferencias bancarias reflejadas en cuenta 24 horas antes del último día del mes, sin considerar sábados, domingos y días festivos.</li>
                <li>Cheques al cobro 48 horas antes del último día del mes, sin considerar sábados, domingos y días festivos.</li>
            </ul>
            <p className="politicas-texto">
                La factura fiscal se realizará de acuerdo a lineamientos establecidos por el SAT, enviando por correo PDF y XML en un lapso no mayor de 48 horas.<br />
                El cliente tendrá un lapso de 48 horas a partir de la fecha de envío para cualquier duda o aclaración de la misma.<br />
                Para aclaraciones de facturación se tiene como fecha límite 24 horas antes del último día del mes, sin considerar sábados, domingos y días festivos.
            </p>
            <div className="politicas-imagen">
                <img
                    src={factory}
                    alt="Energía sostenible"
                />
            </div>

        </div>
    );
};

export default Factory;